import { Box, Button, Typography } from '@mui/material';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';

interface StepUnauthorizedProps {
  setStepLogin: (type: AuthSectionSteps) => void;
}

export const StepUnauthorized = ({ setStepLogin }: StepUnauthorizedProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="10px"
      padding="10px 60px"
      width="100%"
    >
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: '700',
          color: '#9E9E9E',
          textAlign: 'center',
        }}
      >
        Ocorreu um erro ao tentar acessar sua conta, entre em contato com o
        suporte da TEN.
      </Typography>

      <Button
        variant="outlined"
        sx={{ height: '54px', marginTop: '30px' }}
        onClick={() => setStepLogin(AuthSectionSteps.LOGIN)}
      >
        Voltar ao Login
      </Button>
    </Box>
  );
};
